/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import { get } from 'lodash-es';

import { UPDATE_THEME } from '../../Services/Theme/actionTypes';

export const themeMiddleware = store => next => action => {
  const localTheme = JSON.parse(localStorage.getItem('theme'));
  try {
    if (localTheme && get(action, 'type') !== UPDATE_THEME) {
      next(action);
      return store.dispatch({
        type: UPDATE_THEME,
        theme: localTheme,
      });
    }
  } catch (error) {
    localStorage.setItem('theme', JSON.stringify({ current: 'coog' }));
  }
  next(action);
};
